import { LocalStorageRepository } from './local-storage.repository';

export class LocalStorageRepositoryImpl implements LocalStorageRepository {
	get(key: string): string | null {
		return localStorage.getItem(key);
	}

	set(key: string, value: string): void {
		localStorage.setItem(key, value);
	}

	remove(key: string): void {
		localStorage.removeItem(key);
	}
}